
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('Section-{{ section.id }}');
    if (!root) return;
    var video = root.querySelector('video.iwt-autoplay');
    if (!video) return;

    // Гарантируем mute/inline для автоплея на iOS/Android
    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          // Пытаемся запустить
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function(){}); }
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.5, 1] });

    io.observe(video);

    // На смену видимости вкладки — ставим на паузу, чтобы не жрало ресурс
    document.addEventListener('visibilitychange', function(){
      if (document.hidden) video.pause();
      else {
        var inViewport = video.getBoundingClientRect().top < window.innerHeight &&
                         video.getBoundingClientRect().bottom > 0;
        if (inViewport) {
          var p = video.play();
          if (p && typeof p.catch === 'function') { p.catch(function(){}); }
        }
      }
    });
  });

